const SvgIconChevronSelector = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M7 9l5-5 5 5"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 15l5 5 5-5"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgIconChevronSelector
